import Description from './Description.vue';
export default Description;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/tabs/description/index.ts